const options = {
  5: "bg-indigo-400/5",
  10: "bg-indigo-400/10",
  25: "bg-indigo-400/25",
  50: "bg-indigo-400/50",
  75: "bg-indigo-400/75",
  90: "bg-indigo-400/90",
  100: "bg-indigo-400",
};

const from = {
  5: "from-indigo-400/5",
  10: "from-indigo-400/10",
  25: "from-indigo-400/25",
  50: "from-indigo-400/50",
  75: "from-indigo-400/75",
  90: "from-indigo-400/90",
  100: "from-indigo-400",
};

export default function getBackgroundIndigo400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
  